var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331.703,
    height: 236.784,
    viewBox: "0 0 331.703 236.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3223",
    "data-name": "Group 3223",
    transform: "translate(-2309.635 3215.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DpeKeX",
    transform: "translate(2310.635 -3215.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7573",
    "data-name": "Path 7573",
    d: "M2904.729-3165.519c-1.621-6.784-4.426-13.306-4.735-20.371a49.918,49.918,0,0,1,.626-6.924c1-1.472,1.964-3.5,3.692-3.647,6.319-.554,7.993-5.388,10.562-9.962,4.762-8.482,15.5-12.189,24.107-7.218,9.948,5.745,19.628,12.25,27.576,20.834,2.771,7.537.511,14.654-1.828,21.758-.733,2.228-1.541,4.431-2.315,6.645.53,2.24-.237,4.444-2.33,4.711-2.316.3-3.089-2.2-3.351-4.141-.579-4.3-.715-8.649-1.441-12.928-.2-1.317.17-2.655-.1-4.159-8.3,4.576-15.727,2.583-22.885-2.693-3.83-2.823-7.529-6.62-13.108-4.2-6.439,3.488-6.87,10-7.965,16.082-.516,2.863-.46,5.838-1.346,8.645-.439,1.392-.511,3.5-2.508,3.36-1.737-.119-2.32-1.863-2.532-3.489C2904.746-3163.977,2905.035-3164.764,2904.729-3165.519Z",
    transform: "translate(-2760.816 3215.879)",
    fill: "#210e4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7574",
    "data-name": "Path 7574",
    d: "M3044.571-2468.92q-68.7.055-137.391.118c-2.365,0-4.729.119-7.093.182l-1.075-.106c-4.324-.664-5.259-3.74-4.86-7.36.394-3.571,3.128-4.761,6.31-4.989,4.9-.351,9.809-.2,14.708-.16,5.293.141,10.6-.161,15.894.075,4.222.189,6.742-1.437,7.443-5.663q4.952-21.319,10.147-42.58c1.021-3.178,1.519-6.469,2.224-9.714.889-4.094,2.875-7.273,7.323-8.251,19.9-.437,39.8-.108,59.7-.178a9.52,9.52,0,0,1,5.143,1.039c.864.428,1.586,1.209,2.637,1.194,11.957-.175,23.927.659,35.872-.446,3.7,1.022,2.8,3.921,2.253,6.273-5.016,21.676-10.191,43.315-15.205,64.991C3048.009-2471.932,3046.32-2470.481,3044.571-2468.92Z",
    transform: "translate(-2756.299 2705.403)",
    fill: "#efede1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7575",
    "data-name": "Path 7575",
    d: "M2982.165-2708.11l-10.075,42.686c-7.776-3.135-16.552-3.669-23.5-9.013a5.472,5.472,0,0,0-4.085-3.085c-4.644-.725-6.007-3.848-6.039-8.054-.1-13.393-1.671-26.727-1.314-40.154.409-15.361-1.906-30.679-1.112-46.064.151-2.915-.385-5.973,1.759-8.475,2.111-2.135,4.777-1,7.212-1.223a3.474,3.474,0,0,1,1.328,1.888c2.606,8.042,7.1,11.55,14.8,11.548s12.155-3.484,14.811-11.541a3.376,3.376,0,0,1,1.349-1.869c2.382-.141,4.764-.28,6.931,1.029,3.48,5.015,2.224,10.7,1.728,16.029a138.113,138.113,0,0,0-.773,21.2C2985.909-2731.325,2983.766-2719.755,2982.165-2708.11Z",
    transform: "translate(-2788.233 2884.147)",
    fill: "#ffd400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7576",
    "data-name": "Path 7576",
    d: "M2933.589-3029.347c-.365,9.919-5.983,15.2-16.164,15.189-10.2-.008-15.785-5.285-16.118-15.217.353-7.235,1.3-14.63-5.568-19.86a2.881,2.881,0,0,1-.816-1.551c-1.515-6.188-4.839-10.111-10.723-13.634-8.937-5.352-6.742-12.69,4.24-17.251l3.078,6.047c1.022-6.759,1.576-12.8,2.934-18.654,1.085-4.68,2.469-9.636,8.14-11.21,3.8-1.742,6.606.5,8.919,2.8,4.211,4.188,8.87,7.825,13.328,11.7,4.9,3.834,6.712,3.881,9.319.217,1.63-2.086,3.161-4.4,6.4-2.81.7,5.737,1.408,11.473,2.129,17.348,2.459-.678,1.869-3.332,3.44-4.324,5.226-.47,8.806,2.343,9.424,6.986.722,5.421-2.85,9.688-7.828,11.19-4.208,1.27-5.158,3.727-6.135,7.331-1.346,4.96-3.829,9.466-8.235,12.561-4.531,6.591-12.9,8.871-22.612,6.18-1.358-.454-2.424-1.636-4.342-1.708a6.2,6.2,0,0,1,2.516.913c6.33,3.393,12.922,4.59,19.949,2.539,1.5-.438,3.073-.887,4.5.287Z",
    transform: "translate(-2744.526 3132.029)",
    fill: "#feb0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7577",
    "data-name": "Path 7577",
    d: "M3166.522-2775.011c7.22,1.072,14.482,1.918,21.65,3.269a31.424,31.424,0,0,1,22.723,16.5c6.222,11.46,12.22,23.04,18.315,34.569-9,1.1-18.035.339-27.052.462-11.011.15-22.027-.058-33.039.092-15.236,1.488-5.271-1.038-5.375-4.551-.13-2.586-.058-5.178-.084-7.767.039-4.6-.013-9.206.047-13.811a11.134,11.134,0,0,1,.371-3.082c1.562-5.239.5-10.611.783-15.917-.021-.674-.023-1.346-.021-2.021C3165.125-2769.911,3164.282-2772.8,3166.522-2775.011Z",
    transform: "translate(-2962.186 2879.116)",
    fill: "#ec3438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7578",
    "data-name": "Path 7578",
    d: "M3142.341-2768.315q-.033.67-.065,1.34c-2.451,5.294-.494,10.884-1.094,16.3v2.4c-1.413,4.55-.257,9.218-.636,13.816a13.864,13.864,0,0,1-.178,2.979c-1.276,3.4.929,7.363-1.7,10.545-4.054,2.121-4.1,6.2-5.084,9.934-.579,2.21.043,4.743-1.675,6.65q1.032-36.166,2.063-72.328l7.219.3C3142.655-2773.84,3140.765-2770.829,3142.341-2768.315Z",
    transform: "translate(-2937.974 2880.387)",
    fill: "#29b4e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7579",
    "data-name": "Path 7579",
    d: "M3026.189-2828.475c-9.051,3.5-17.811,3.736-26.01-2.319-.09-2.164,1.019-1.925,2.376-1.184,8.671,2.427,16.512.7,23.62-4.708Q3026.182-2832.58,3026.189-2828.475Z",
    transform: "translate(-2837.349 2926.227)",
    fill: "#f58c8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7580",
    "data-name": "Path 7580",
    d: "M3232.074-2574.816a.834.834,0,0,1-1.237.469C3208.578-2574.467,3231.514-2575.119,3232.074-2574.816Z",
    transform: "translate(-2963.37 2734.163)",
    fill: "#efede1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7581",
    "data-name": "Path 7581",
    d: "M3443.317-2541.6l1.238-.469c12.186-.175,24.375-.732,36.552.3-3.244,2.2-6.9,1.1-10.307.992C3461.639-2541.054,3452.419-2539.539,3443.317-2541.6Z",
    transform: "translate(-3175.85 2701.411)",
    fill: "#efede1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7582",
    "data-name": "Path 7582",
    d: "M3171.485-2767.689c-2.556-2.375-.829-5.361-1.152-8.055a1.114,1.114,0,0,1,1.121.088Q3171.47-2771.672,3171.485-2767.689Z",
    transform: "translate(-2967.118 2879.76)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7583",
    "data-name": "Path 7583",
    d: "M2358.258-2831.951c2.435.071,4.91-.114,7.167,1.108,5.229,3.078,4.75,8.213,4.746,13.177q0,2.374,0,4.748-.034,17.114-.076,34.227c-.008,2.312.5,4.857-2.307,6.135a10.741,10.741,0,0,1-7.493,1.775c-12.992.19-25.986.505-38.976-.124-2.659-.087-5.062-.772-6.823-2.942-5.66-5.452-3.005-12.566-3.8-18.992q-.031-13.6-.063-27.2c.7-9.785,2.909-11.831,12.791-11.849Z",
    transform: "translate(-2311.635 2936.61)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7584",
    "data-name": "Path 7584",
    d: "M2613.9-2644.562l-75.775.051c-9.908-2.231-16.834-7.433-18.375-18.169-.713-4.966.889-9.334,3.07-13.607q5.246-10.28,10.495-20.558c7.01-11.4,13.088-23.3,18.956-35.313,2.846-5.141,6.209-10.068,8.447-15.461,7.631-18.394,21.573-27.246,41.042-28.334,2.931-.164,5.846-.626,8.768-.949,1.421,1.679-.441,4.12.856,5.381a8.045,8.045,0,0,1,.258-5.463c2.716-.38,5.432-.833,8.166-.142.834,32.281,1.72,64.562,2.428,96.847.076,3.457,1.313,4.634,4.5,4.15,4.56-.692,6.694.863,5.413,5.694,1.9,5.535,1.353,10.691-2.37,15.358-4.333.084-8.681-.009-13,.321-2.476.189-5.977-1.632-7.1,2.213C2608.6-2648.8,2610.379-2646.109,2613.9-2644.562Z",
    transform: "translate(-2470.24 2881.007)",
    fill: "#ec3438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7585",
    "data-name": "Path 7585",
    d: "M2905.729-2775.731v6.6c-1.767-2.547-.919-4.609-1.112-6.52A1.1,1.1,0,0,1,2905.729-2775.731Z",
    transform: "translate(-2764.327 2879.752)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7586",
    "data-name": "Path 7586",
    d: "M3017.978-3094.694c-2.476.335-4.135,2.04-5.925,3.527-3.572,2.155-7.125.607-10.682-.057a69.5,69.5,0,0,1-14.109-12.3,8.531,8.531,0,0,0-7.252-3.08c4.83-2.269,8.942-.215,12.334,2.791,7.673,6.8,15.814,8.923,25.633,3.295Z",
    transform: "translate(-2821.947 3133.144)",
    fill: "#f38a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7587",
    "data-name": "Path 7587",
    d: "M2986.263-2308.792q1.184-7.679,2.369-15.359c7.711,1.656,15.53,3.02,21.947,8.155.083,6.238-2.865,8.479-9.079,7.691C2996.482-2308.942,2991.347-2308.665,2986.263-2308.792Z",
    transform: "translate(-2826.723 2534.72)",
    fill: "#feb0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7588",
    "data-name": "Path 7588",
    d: "M3034.7-2978.861c1.053,3.414,1.829,5.951,2.619,8.484.41,1.313,1.1,2.925-.734,3.441a8.265,8.265,0,0,1-4.568-.127c-1.347-.442-.949-1.917-.569-3.06C3032.3-2972.692,3032.323-2975.539,3034.7-2978.861Z",
    transform: "translate(-2860.961 3034.83)",
    fill: "#fe5f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7589",
    "data-name": "Path 7589",
    d: "M3070.468-3040.9c3.569-1.594,7.123-.338,10.682.057.754.831,2.044,1.688.638,2.836C3079.125-3035.829,3072.525-3037.581,3070.468-3040.9Z",
    transform: "translate(-2891.044 3082.82)",
    fill: "#412457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7590",
    "data-name": "Path 7590",
    d: "M2975.827-3038.83c-.25.65-.265.917-.394.992-3.7,2.148-7.538,2.807-11.531.879-.219-.106-.292-1.013-.105-1.38C2964.766-3040.244,2971.814-3040.539,2975.827-3038.83Z",
    transform: "translate(-2809.48 3081.497)",
    fill: "#43295c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7591",
    "data-name": "Path 7591",
    d: "M3086.8-2997.839c1.781.267,2.75,1.177,2.535,2.719a2.259,2.259,0,0,1-2.394,2.021c-1.726-.041-2.348-1.158-2.225-2.675A2.133,2.133,0,0,1,3086.8-2997.839Z",
    transform: "translate(-2901.917 3049.326)",
    fill: "#341f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7592",
    "data-name": "Path 7592",
    d: "M2990.462-2995.445c-.228,1.618-.9,2.491-2.262,2.474a2.224,2.224,0,0,1-2.454-2.521,2.273,2.273,0,0,1,2.828-2.136A2.223,2.223,0,0,1,2990.462-2995.445Z",
    transform: "translate(-2826.321 3049.189)",
    fill: "#321e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7593",
    "data-name": "Path 7593",
    d: "M3031.115-2896.38c-2.616,1.953-4.3,2.047-6.5.408C3026.647-2897.436,3028.429-2897.111,3031.115-2896.38Z",
    transform: "translate(-2856.019 2972.298)",
    fill: "#b5441e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7594",
    "data-name": "Path 7594",
    d: "M2993.316-2823.081a2.549,2.549,0,0,0-2.376,1.184,4.567,4.567,0,0,1-2.861-3.142C2990.125-2824.88,2991.888-2824.5,2993.316-2823.081Z",
    transform: "translate(-2828.109 2917.329)",
    fill: "#f99496"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7595",
    "data-name": "Path 7595",
    d: "M2899.621-2974.456a5,5,0,0,1-4.475-.066C2896.785-2976.45,2898.077-2976.435,2899.621-2974.456Z",
    transform: "translate(-2757.122 3032.609)",
    fill: "#563363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7596",
    "data-name": "Path 7596",
    d: "M3171.048-2973.808c1.317-2.682,2.687-2.12,4.309-1.494C3174.313-2972.706,3172.741-2974.392,3171.048-2973.808Z",
    transform: "translate(-2967.873 3032.508)",
    fill: "#593564"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7597",
    "data-name": "Path 7597",
    d: "M3157.5-2953.849c-.908-.58-1.243-1.278-.816-2.03.23-.406.98-.921,1.279-.809a1.283,1.283,0,0,1,.635,1.885C3158.393-2954.386,3157.85-2954.135,3157.5-2953.849Z",
    transform: "translate(-2956.765 3017.904)",
    fill: "#8a577a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7598",
    "data-name": "Path 7598",
    d: "M3166.133-2719.3c-1.183-5.539-3.3-11.141,1.095-16.3C3166.723-2730.18,3168.424-2724.607,3166.133-2719.3Z",
    transform: "translate(-2962.926 2849.016)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7599",
    "data-name": "Path 7599",
    d: "M3165.492-2642.019c.332-4.793-1.282-9.746,1.178-14.365q-.1,7.174-.207,14.349C3166.149-2641.449,3165.825-2641.47,3165.492-2642.019Z",
    transform: "translate(-2963.464 2788.501)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7600",
    "data-name": "Path 7600",
    d: "M3165.723-2595.6q.486,0,.972-.016.005,3.5.01,7c-1.512-1.317-.722-3.179-1.128-4.757Q3165.65-2594.483,3165.723-2595.6Z",
    transform: "translate(-2963.695 2742.081)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7601",
    "data-name": "Path 7601",
    d: "M2374.493-2679.623c-4.153.006-8.314-.169-12.455.05-5.087.27-6-2.6-5.656-6.747.321-3.866-1.5-8.962,5.316-8.962q13.347,0,26.695,0c3.4-.005,5.151,1.53,5,5.055-.083,1.973-.071,3.955-.006,5.93.108,3.251-1.488,4.7-4.661,4.677C2383.984-2679.65,2379.239-2679.628,2374.493-2679.623Z",
    transform: "translate(-2346.53 2832.215)",
    fill: "#ffd400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7602",
    "data-name": "Path 7602",
    d: "M2373.163-2745.333c4.348,0,8.7-.016,13.044.012,1.025.007,2.154.321,2.2,1.479.044,1.179-1.059,1.553-2.091,1.556q-13.044.043-26.089.022c-1.017,0-2.189-.288-2.161-1.479.038-1.6,1.48-1.589,2.646-1.6,4.151-.033,8.3-.013,12.453-.013Z",
    transform: "translate(-2347.864 2870.465)",
    fill: "#97c899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7603",
    "data-name": "Path 7603",
    d: "M2367.3-2779.07c-2.572,0-5.144.024-7.715-.01-1.213-.016-2.531-.165-2.583-1.743-.055-1.675,1.332-1.7,2.505-1.707q8.308-.041,16.618.006c.956.006,2.1.007,2.26,1.325.19,1.571-.917,2.053-2.183,2.079-2.966.062-5.934.02-8.9.02Z",
    transform: "translate(-2347.053 2898.873)",
    fill: "#64af6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7604",
    "data-name": "Path 7604",
    d: "M2654.654-2514.655l27.595-49.747c1.853,3.319.048,5.672-.527,7.917-3.309,12.942-6.952,25.8-10.486,38.684-.527,1.921-1.008,4.117-3.5,4.14-11,.1-21.942,2.261-32.979,1.029-.489-.054-.916-.667-1.371-1.02C2640.423-2515.12,2647.615-2513.254,2654.654-2514.655Z",
    transform: "translate(-2557.174 2718.239)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7605",
    "data-name": "Path 7605",
    d: "M2910.359-2585.6c2.369,5.038.84,10.348,1.085,15.534-.946,1.01.148,2.66-1.121,3.568-1.907-6.4-1.348-12.789.108-19.172Z",
    transform: "translate(-2767.784 2734.484)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7606",
    "data-name": "Path 7606",
    d: "M2916.527-2419.374c.935,4.836,1.392,9.632-.2,14.421C2915.215-2409.761,2914.805-2414.578,2916.527-2419.374Z",
    transform: "translate(-2772.565 2607.458)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7607",
    "data-name": "Path 7607",
    d: "M2905.371-2716.221a26.434,26.434,0,0,1,1.158-18.661v12.857c-.965,1.684-.15,3.557-.566,5.3C2905.767-2716.556,2905.569-2716.389,2905.371-2716.221Z",
    transform: "translate(-2764.046 2848.462)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7608",
    "data-name": "Path 7608",
    d: "M2654.653-2354.6c-7,2.3-14.184.557-21.268,1C2640.378-2355.97,2647.566-2354.222,2654.653-2354.6Z",
    transform: "translate(-2557.172 2558.185)",
    fill: "#2d1a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7609",
    "data-name": "Path 7609",
    d: "M2910.246-2640.588c-2.506-5.36-.722-11.062-1.322-16.573l.29.041c.27-.576.546-.607.831-.01q.064,8.306.128,16.611Z",
    transform: "translate(-2767.598 2789.403)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7610",
    "data-name": "Path 7610",
    d: "M2915.843-2491.3v12.108l-.976,0v-12.122C2915.2-2491.882,2915.522-2491.85,2915.843-2491.3Z",
    transform: "translate(-2772.186 2662.724)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7611",
    "data-name": "Path 7611",
    d: "M2915.386-2512.583q-.488-.01-.977-.01-.07-1.716-.141-3.432c.254-1.226-.119-2.651,1.12-3.568Q2915.387-2516.087,2915.386-2512.583Z",
    transform: "translate(-2771.73 2684.011)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7612",
    "data-name": "Path 7612",
    d: "M2910.606-2674.6l-.417-.007-.415.017c.062-1.983-.828-4.107.87-5.846Q2910.625-2677.517,2910.606-2674.6Z",
    transform: "translate(-2768.16 2806.873)",
    fill: "#154f9e"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_299",
    "data-name": "Ellipse 299",
    cx: 8.064,
    cy: 8.064,
    r: 8.064,
    transform: "translate(2548.315 -3027.899)",
    fill: "#154f9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7618",
    "data-name": "Path 7618",
    d: "M12,0H43.945a12,12,0,0,1,12,12V43.945a12,12,0,0,1-12,12H12a12,12,0,0,1-12-12V12A12,12,0,0,1,12,0Z",
    transform: "translate(2584.892 -3173.866)",
    fill: "#fefefe",
    stroke: "#edeff2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7613",
    "data-name": "Path 7613",
    d: "M3540.5-2991.792a11.42,11.42,0,0,1,11.423-11.712,11.854,11.854,0,0,1,12.208,11.7,12.044,12.044,0,0,1-12.2,11.8A11.669,11.669,0,0,1,3540.5-2991.792Z",
    transform: "translate(-939.447 -162.223)",
    fill: "#4fa457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7614",
    "data-name": "Path 7614",
    d: "M3528.828-2876.715c9.185,0,18.369-.01,27.554.019.761,0,1.667.217,1.566,1.25-.044.448-.592,1.211-.915,1.213-9.41.065-18.82.053-28.231.053Q3528.815-2875.447,3528.828-2876.715Z",
    transform: "translate(-930.514 -259.074)",
    fill: "#4ca355"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7615",
    "data-name": "Path 7615",
    d: "M3552.355-2839.5H3568.9c-5.407,2.377-10.954,1.706-16.467,1.719Q3552.394-2838.638,3552.355-2839.5Z",
    transform: "translate(-948.505 -287.503)",
    fill: "#99ca9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7616",
    "data-name": "Path 7616",
    d: "M3580.809-2953.444c.654-1.05-.2-2.9,1.643-3.283a2.234,2.234,0,0,1,2.469,1.07c.994,1.706.4,2.874-1.381,3.536C3582.656-2952.616,3581.318-2952.175,3580.809-2953.444Z",
    transform: "translate(-970.24 -197.915)",
    fill: "#edf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7617",
    "data-name": "Path 7617",
    d: "M3582.806-2944.111l2.731,1.324a2.463,2.463,0,0,1-4.238-.667C3580.489-2945.148,3581.978-2944.5,3582.806-2944.111Z",
    transform: "translate(-970.436 -207.248)",
    fill: "#f2f8f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRight);
export default __webpack_public_path__ + "static/media/dashboardRight.565f57c0ed90ec2a5e6482161705191d.svg";
export { ForwardRef as ReactComponent };